var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forget_main"},[_c('a-steps',{attrs:{"current":_vm.current}},_vm._l((_vm.steps),function(item){return _c('a-step',{key:item.title,attrs:{"title":item.title}})}),1),_c('div',{staticClass:"steps-content"},[_c(_vm.steps[_vm.current]['comp'],{tag:"component",attrs:{"safeSetInfo":_vm.safeSetInfo,"safeParams":_vm.safeParams},on:{"next":(val, params = null) => {
          _vm.current = val;
          if (val == 2) _vm.safeParams = params;
        },"success":() => _vm.$emit('success')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }